import WebsocketGateway from "@mittwald/flow-app-utils/dist/api/WebsocketGateway";

export const websocketGateway = new WebsocketGateway();
export default websocketGateway;
